module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-18.b68f61f6.png";